// OwnedTaskDetails.js
import React from "react";
import { Badge, Button, ListGroup } from "react-bootstrap";

const OwnedTaskDetails = ({ task, t, handleDownload }) => (
  <div>
    <div className="mb-2">
      <strong>{task.referenceNumber} - {task.chapter.title}</strong>
      <Badge bg="secondary" className="ms-2">
        {task.chapter.book.title}
      </Badge>
    </div>
    <div className="text-muted small mb-2">
      <strong>{t.createdOn}</strong>{new Date(task.createdAt).toLocaleString()}
    </div>
    <div className="mb-2">
      <strong>{t.responsible || 'Responsável'}:</strong> {task.responsible.name}
    </div>
    <div className="mb-2">
      <strong>{t.instructions}</strong> {task.instructions || t.none}
    </div>
    {task.comments && task.comments.length > 0 && (
      <div className="mt-2">
        <strong>{t.relatedComments || 'Comentários Relacionados'}</strong>
        <ListGroup className="mt-2">
          {task.comments.map(comment => (
            <ListGroup.Item key={comment.id} className="py-2">
              <div>"{comment.text}"</div>
              <div className="d-flex gap-2 mt-1">
                {comment.pageNumber && (
                  <Badge bg="secondary">
                    {t.pageNumber}{comment.pageNumber}
                  </Badge>
                )}
                {comment.sugestionType && (
                  <Badge bg="info">
                    {comment.sugestionType}
                  </Badge>
                )}
                {comment.Base64 && comment.nameBase64 && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleDownload(comment.Base64, comment.nameBase64)}
                  >
                    Download: {comment.nameBase64}
                  </Button>
                )}
              </div>
              <small className="text-muted">
                {t.by || 'por'} {comment.creator.name} - {new Date(comment.createdAt).toLocaleString()}
              </small>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    )}
  </div>
);

export default OwnedTaskDetails;